module.exports = __webpack_public_path__ + "media/images/home/ic_comment-c7aad80bef1b8979feb38b6ebe628611.svg";